import { Stack } from "@mui/material";
import classes from "./MainLayout.module.scss";
import { ReactNode } from "react";
import AdminHeaderComponent from "../../features/header-component/AdminHeaderComponent";
import FooterComponent from "../../components/footer-component/FooterComponent";

interface MainLayoutProps {
  children: ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  return (
    <div className={classes.mainLayout}>
      <AdminHeaderComponent />
      <Stack spacing={2} className={classes.content}>
        {children}
      </Stack>
      <FooterComponent />
    </div>
  );
};

export default MainLayout;
